import React, { useEffect, useState } from "react";
import { useChartContext } from "../../Context/ChartsContext";
import LineRaceChart from "../../CHARTS/LineRaceChart";
import DottedBarChart from "../../CHARTS/DottedBarChart";
import { MdVisibility } from "react-icons/md";
import { getDaysInMonth } from "../../Utilitie";
const MexpPassTRks = () => {
  const { bestSheetDataObj } = useChartContext();
  const [visibleTable, setVisibleTable] = useState(null);
  const [bestSheetData, setBestSheetData] = useState(null);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    setVisibleTable(bestSheetDataObj.visibleTable);
    setBestSheetData(bestSheetDataObj.bestSheetData);
  }, [bestSheetDataObj]);
  useEffect(() => {
    if (bestSheetData && visibleTable) {
      let newChartData = [];

      Object.entries(visibleTable).forEach(([key, value]) => {
        if (value) {
          bestSheetData.forEach((fyObj) => {
            if (fyObj.F_YEAR === key) {
              fyObj.months.forEach((monthObj) => {
                let days = getDaysInMonth(
                  fyObj.F_YEAR,
                  monthObj.A_MONTH.toUpperCase()
                );
                newChartData.push({
                  time: `${monthObj.A_MONTH}\n${fyObj.F_YEAR.replace(
                    "_",
                    "-"
                  )}`,
                  MEXP: (monthObj.data.MEXP_RPT / days).toFixed(0),
                  PASS: (monthObj.data.PASS_RPT / days).toFixed(0),
                  GOODS: (monthObj.data.TOTAL_RKS / days).toFixed(0),
                  SPEED: monthObj.data.SPEED,
                  // TotalTrain: (
                  //   monthObj.data.MEXP_RPT / days +
                  //   monthObj.data.PASS_RPT / days +
                  //   monthObj.data.TOTAL_RKS / days
                  // ).toFixed(0),
                });
              });
            }
          });
        }
      });

      setChartData(newChartData);
    }
  }, [visibleTable, bestSheetData]);

  return (
    <div>
      <div className="bg-dark text-white p-1">
        <h5>
          MEXP | PASS | GOODS avg day data for years =
          {visibleTable &&
            Object.entries(visibleTable).map(([key, value], index) => {
              return (
                <React.Fragment key={index}>
                  {value ? `${key.replace("_", "-")}, ` : null}
                </React.Fragment>
              );
            })}
        </h5>
      </div>
      <LineRaceChart
        data={chartData}
        title={"MEXP,PASS,GOODS performance graph"}
      />
      {/* <DottedBarChart data={chartData} /> */}
    </div>
  );
};
export default MexpPassTRks;
